<template>
  <div class="tableContainer">
    <!--TABLA DE VUETIFY-->
    <v-data-table
      :headers="fields"
      :items="data"
      :item-key="itemKey"
      class="elevation-3"
      multi-sort
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
    >
      <template v-slot:top>
        <!-- <v-toolbar text v-if="title == 'Buques'">
          <v-btn text :loading="isDownloading">
            <download-excel
              class="btn btn-default"
              :data="data"
              :fields="json_fields"
              worksheet="Buques"
              name="buques.xls"
            >
              <v-icon>mdi-google-spreadsheet</v-icon> Descargar datos en Excel
            </download-excel>
          </v-btn>
          <loader-anim v-if="isDownloading"></loader-anim>
        </v-toolbar> -->
        <v-toolbar text>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            style="padding-right: 1em"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="1600px" :key="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Añadir {{ element }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <optional-modals
                  ref="optModals"
                  :info="editedItem"
                  :element="element"
                ></optional-modals>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Continuar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5 justify-center"
                >¿Está seguro de querer eliminar este elemento de la
                tabla?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Sí, quiero eliminarlo</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!--Slots columnas concretas-->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ parseFecha(item.fecha) }}
      </template>
      <template v-slot:[`item.habilitado`]="{ item }">
        <v-checkbox
          color="#004283"
          v-model="item.habilitado"
          @change="update(item)"
        ></v-checkbox>
      </template>
      <template v-slot:[`item.lleno`]="{ item }">
        <v-checkbox
          color="#004283"
          v-model="item.lleno"
          @change="update(item)"
        ></v-checkbox>
      </template>
      <template v-slot:[`item.precio`]="{ item }">
        <v-chip color="green" dark> {{ item.precio }}€ </v-chip>
      </template>
      <template v-slot:no-data>
        <v-row v-if="isLoading">
          <v-divider></v-divider>
          <h5>Datos cargando. Por favor, espere.</h5>
          <v-divider></v-divider>
          <h5><loader-anim></loader-anim></h5>
        </v-row>
        <div v-else-if="!isLoading">
          <h5>No existen datos para los filtros señalados.</h5>
        </div>
      </template>
      <!--Fin de Slots columnas concretas-->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <my-detail-row :item="item" :key="item.id"></my-detail-row>
        </td>
      </template>
    </v-data-table>
    <!-- Snackbar Resultados -->
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> cerrar </v-btn>
      </template>
    </v-snackbar>
    <v-row class="text-center px-4 pageCustom" wrap>
      <v-col cols="12" md="6" align="center">
        <v-pagination v-model="page" :length="pageCount"> </v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import apiConfig from "../../services/api.config";
import VueEvents from "vue-events";
import LoaderAnim from "../ui/LoaderAnim.vue";
Vue.use(VueEvents);
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  components: { LoaderAnim },
  data() {
    return {
      isDownloading: false,
      isLoading: false,
      //VUETIFY TABLE
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 13,
      snack: false,
      snackColor: "",
      snackText: "",
      expanded: [],
      singleExpand: false,
      data: [],
      json_fields: {}
    };
  },
  props: {
    fields: Array,
    title: String,
    element: String,
    url: String,
    itemKey: { type: String, default: "id" }, //PARA INDIVIDUALIZAR LA APERTURA DE DETAILROW AL REGISTRO CLICKADO
    id: Number
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear " + this.element
        : "Editar " + this.element;
    }
  },
  beforeDestroy() {
    this.data = null;
  },
  created() {
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    getTitle() {
      return this.title;
    },
    getElement() {
      return this.element;
    },
    initialize() {
      this.init();
    },
    capitalizeFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getRol(roles) {
      return this.capitalizeFirst(roles[roles.length - 1]);
    },
    parseFecha(fecha) {
      var m = new Date(fecha);
      var hh = m.getHours();
      var mins = m.getMinutes();
      var secs = m.getSeconds();
      var hourtime = [
        (hh > 9 ? "" : "0") + hh,
        (mins > 9 ? "" : "0") + mins,
        (secs > 9 ? "" : "0") + secs
      ].join(":");
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear() +
        " " +
        hourtime;
      return nf;
    },
    parsePrioridad(prio) {
      var nf = prio.nombre;
      return nf;
    },
    parseTipoInc(ti) {
      var nf = ti;
      return nf;
    },
    setIsLoading() {
      this.isLoading = !this.isLoading;
    },
    async init() {
      await this.setIsLoading();
      await axios
        .get(this.url, apiConfig.connData())
        .then(response => {
          this.data = response.data;
        })
        .catch(e => {
          this.snackText =
            "Error al recoger la información de la Base de Datos";
          this.snackColor = "error";
          this.snack = true;
        });
      await this.setIsLoading();
    },
    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      if (this.url.includes("piezometro")) {
        axios
          .delete(
            this.url.split("/piezometro/")[0] + "/" + this.editedItem.id,
            apiConfig.connData()
          )
          // eslint-disable-next-line
          .then(response => {})
          .catch(e => {
            console.log(e);
          });
      } else {
        axios
          .delete(this.url + "/" + this.editedItem.id, apiConfig.connData())
          // eslint-disable-next-line
          .then(response => {
            //this.initialize();
          })
          .catch(e => {
            console.log(e);
          });
      }

      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.init();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.init();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editElement() {
      if (this.element == "Usuario") {
        if (
          this.editedItem.email == undefined ||
          this.editedItem.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) == null ||
          this.editedItem.email == ""
        ) {
          this.snackText = "Escriba un email válido";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.username == "") {
          this.snackText = "Escriba un nombre de usuario válido";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.nombre == "") {
          this.snackText = "Escriba un nombre";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.password == "") {
          this.snackText = "Escriba una contraseña";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else {
          axios
            .put(
              this.$baseBackUrl + "api/usuarios/" + this.editedItem.id,
              this.editedItem,
              apiConfig.connData()
            )
            .then(response => {
              this.snackText = "Registro actualizado";
              this.snackColor = "success";
              this.snack = true;
              this.close();
            })
            .catch(e => {
              this.snackText = "Email ya existente en el sistema";
              this.snackColor = "error";
              this.snack = true;
            });
        }
      } else {
        console.log(this.url)
        axios
          .put(
            this.url + "/" + this.editedItem.id,
            this.editedItem,
            apiConfig.connData()
          )
          // eslint-disable-next-line
          .then(response => {
            this.snackText = "Registro actualizado";
            this.snackColor = "success";
            this.snack = true;
            this.close();
          })
          .catch(e => {
            this.snackText = "Error al actualizar la Base de Datos";
            this.snackColor = "error";
            this.snack = true;
          });
      }
    },
    addElement() {
      this.axiosAddItem();
    },
    axiosAddItem() {
      if (this.element == "Usuario") {
        if (
          this.editedItem.email == undefined ||
          this.editedItem.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) == null ||
          this.editedItem.email == ""
        ) {
          this.snackText = "Escriba un email válido";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.username == "") {
          this.snackText = "Escriba un nombre de usuario válido";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.nombre == "") {
          this.snackText = "Escriba un nombre";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (this.editedItem.password == "") {
          this.snackText = "Escriba una contraseña";
          this.snackColor = "error";
          this.snack = true;
          return;
        } else if (
          this.editedItem.password == "" ||
          this.editedItem.password == undefined ||
          this.editedItem.password.match(/.*[A-Z].*/) == null ||
          this.editedItem.password.match(/.*[a-z].*/) == null ||
          this.editedItem.password.match(/.*[0-9].*/) == null ||
          !"[`!@#$%^&*()_+-=[]{};':\"\\|,.<>/?~]"
            .split("")
            .some(sc => this.editedItem.password.includes(sc))
        ) {
          this.snackText = "Escriba una contraseña con el formato correcto";
          this.snackColor = "error";
          this.snack = true;
        } else {
          axios
            .post(
              this.$baseBackUrl + "api/usuarios",
              this.editedItem,
              apiConfig.connData()
            )
            .then(response => {
              this.data.push(response.data);
              this.snackText = "Registro actualizado";
              this.snackColor = "success";
              this.snack = true;
              this.close();
            })
            .catch(e => {
              this.snackText = "Email ya existente en el sistema";
              this.snackColor = "error";
              this.snack = true;
            });
        }
      } else {
        axios
          .post(this.url, this.editedItem, apiConfig.connData())
          .then(response => {
            this.data.push(response.data);
            this.snackText = "Registro actualizado";
            this.snackColor = "success";
            this.snack = true;
            this.close();
          })
          .catch(e => {
            this.snackText = "Error al actualizar la Base de Datos";
            this.snackColor = "error";
            this.snack = true;
          });
      }
    },
    update(item) {
      axios
        .put(this.url + "/" + item.id, item, apiConfig.connData())
        // eslint-disable-next-line
        .then(response => {
          this.snackText = "Registro actualizado";
          this.snackColor = "success";
          this.snack = true;
        })
        .catch(e => {
          this.snackText = "Error al actualizar el registro";
          this.snackColor = "error";
          this.snack = true;
        });
    },
    async save() {
      var res = await this.$refs.optModals.validar();
      if (res) {
        if (this.editedIndex > -1) {
          this.editElement();
        } else {
          this.addElement();
        }
      } else {
        this.snackText = "Complete los campos correctamente";
        this.snackColor = "error";
        this.snack = true;
      }
    }
  }
};
</script>
<style>
.v-input__slot {
  align-items: center;
  justify-content: center;
}
.btn-primary {
  background-color: #004283;
  margin-left: 1em;
  margin-bottom: 1em;
  padding-left: 1em;
}
.bg-blu {
  background-color: #004283;
  color: #fff;
}
.bg-white {
  background-color: #fff;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
button.ui.button {
  padding: 8px 3px 8px 10px;
  margin-top: 1px;
  margin-bottom: 1px;
}
.vuetable-th-gutter {
  width: 0;
}
#ui {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
h1 {
  color: #004283;
}
.v-data-table {
  max-width: 90%;
}
.pageCustom {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tableContainer {
  padding: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/table/MyTable.vue